// ─────────────────────────────────────────────────────────────────────────────
// SaaS & SUBSCRIPTION — industry pack 2 (2026-07-27, a pack since 2026-10-18).
//
// INTERNAL ONLY - not shown in public signup or industry selector
//
// BoneFlow runs its own SaaS business on this industry (roadmap 5.10). Its
// definitions live in saasIndustryUtils.js, the client half of a deliberate
// pair with functions/saasIndustry.js, which seeds boneflow-internal from the
// server — keep those two in sync. This file only registers them as a pack.
//
// No hiddenFeatures and no copy: boneflow-internal is created onboarded and
// never signs up, so it keeps the defaults (every feature visible, the default
// industry's first-run words), exactly as before packs.
// ─────────────────────────────────────────────────────────────────────────────

import {
  SAAS_INDUSTRY_ID,
  SAAS_INDUSTRY_NAME,
  buildSaasJobTypes,
  buildSaasLeadSources,
  buildSaasCostCategories,
  buildSaasCustomFields,
} from '../saasIndustryUtils';
import { buildEmptyPriceBook } from '../priceBookUtils';

// A recurring / renewal loop: two arcs chasing each other with arrow heads at
// 1 o'clock and 7 o'clock — the universal "this repeats every month" mark, and
// the right metaphor for subscription revenue.
const SAAS_SUBSCRIPTION_ICON = {
  viewBox: '0 0 24 24',
  paths: [
    'M23 4 L23 10 L17 10',
    'M1 20 L1 14 L7 14',
    'M3.51 9a9 9 0 0 1 14.85-3.36L23 10',
    'M1 14l4.64 4.36A9 9 0 0 0 20.49 15',
  ],
};

export const SAAS_SUBSCRIPTION_PACK = {
  id: SAAS_INDUSTRY_ID,
  name: SAAS_INDUSTRY_NAME,
  // No signup answer can seed it. Opening it to customers is a signup answer
  // with this id (utils/industryChoices.js and its server mirrors) plus true.
  isPublic: false,
  icon: SAAS_SUBSCRIPTION_ICON,
  buildDefaultJobTypes: buildSaasJobTypes,
  buildDefaultLeadSources: buildSaasLeadSources,
  buildDefaultCostCategories: buildSaasCostCategories,
  buildDefaultCustomFields: buildSaasCustomFields,
  // A software business buys no windows. An empty book is still a SEEDED
  // book, so the seeder leaves it alone afterwards.
  buildDefaultPriceBook: buildEmptyPriceBook,
};
